import { MainLayout } from "@/components/layouts/main-layout";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/_focused",
)({
  component: FocusedLayout,
});

function FocusedLayout() {
  return (
    <MainLayout defaultCollapsed>
      <Outlet />
    </MainLayout>
  );
}
